import Search from 'core/components/Header/Search';
import { HOME_PAGE_LINK } from 'core/store/modules/common/literals';

import styled from 'styled-components';
import { Space } from 'core/components/ui';
import { HeaderWrapper } from './Header.styles';
import { HeaderLogo } from './HeaderLogo';
import { HeaderMenu } from './HeaderMenu';
import type { HeaderProps } from './interface';
import { Help } from './Help';
import { UsersRoles } from './UsersRoles';
import { UserInfo } from './UserInfo';

const RightSide = styled(Space)`
  margin-left: auto;
`;

function Header({ headers, title, customChildren }: HeaderProps) {
  const {
    mainLogo,
    mainLogoLink,
    mainLogoUrl,
    subLogo,
    subLogoLink,
    subLogoUrl,
    menu,
    search,
    userPermission,
    userInfo,
    help,
    tags: Tags,
    simulations: Simulations,
    workspace: Workspace,
  } = headers;

  const children = [];
  let rightSide: JSX.Element[] = [];

  if (mainLogo) {
    children.push(
      <HeaderLogo
        key="mainLogo"
        src={mainLogoUrl}
        link={mainLogoLink || HOME_PAGE_LINK}
        title={headers.title ? title : ''}
      />,
    );
  }

  if (subLogo) {
    children.push(
      <HeaderLogo
        key="subLogo"
        src={subLogoUrl}
        link={subLogoLink || HOME_PAGE_LINK}
        title={headers.title ? title : ''}
        data-test-id="header-sublogo"
      />,
    );
    // children.push(
    //   <img alt={headers.title ? title : ''} key="logo-image" src={logoUrl} height={32} />,
    // );
  }

  if (Workspace) {
    children.push(<Workspace key="workspace" />);
  }

  if (search) {
    children.push(<Search key="search" />);
  }
  if (userInfo) {
    rightSide.push(<UserInfo key="myUser" />);
  }
  if (Tags) {
    rightSide.push(<Tags key="tags" />);
  }

  if (customChildren) {
    rightSide = [...rightSide, ...customChildren];
  }

  if (Simulations) {
    rightSide.push(<Simulations key="simulations" />);
  }

  if (userPermission) {
    rightSide.push(<UsersRoles key="users" />);
  }

  if (help) {
    rightSide.push(<Help key="help" />);
  }

  if (menu) {
    rightSide.push(<HeaderMenu key="menu" />);
  }

  return (
    <HeaderWrapper data-test-id="header">
      {children}
      <RightSide>{rightSide}</RightSide>
    </HeaderWrapper>
  );
}

export { Header };
